// load modernizr first.
// import './modules/modernizr.custom';
import './polyfills';

import $ from 'jquery';

// import external modules
import GA from 'springload-analytics.js';
import { onPageReady, openLinksInNewTab } from './utils';
import header from './modules/header.js';
import mobileMenu from './modules/mobile.menu.js';
import map from './modules/googlemap.js'; // contains google map.
import envolope from './modules/envolope';
import locations from './modules/locations';
import vimeoModal from './modules/vimeo-modal';
import slidersInit from './modules/glide.js';


window.jQuery = $;
window.$ = $;

window.googleMaps = map;

const config = { GA,
    header: '.page__header',
    mobileMenu: '.mobile-menu',
    mobileMenuTrigger: '.mobile-menu-toggle',
    buttons: '.btn',
    ...window.APP_CONFIG };


function initialise() {
    header.init(config);
    mobileMenu.init(config);
    envolope.init();
    GA.init();
    locations.init();
    vimeoModal.init();

    if (window.mapConfigs) {
        window.mapConfigs.forEach((mapConfig) => {
            map.init(mapConfig);
        });
    }

    // Remove all the wacky spacing from empty p tags in wagtail
    $('p').each(function () {
        const $this = $(this);
        if ($this.html().replace(/\s|&nbsp;/g, '').length === 0) {
            $this.remove();
        }
    });

    openLinksInNewTab();

    const sliderElements = document.querySelectorAll('.testimonial_slider, .logo_slider');
    if (sliderElements.length > 0) {
        slidersInit(sliderElements);
    }
}

/* Initialise app */
onPageReady(initialise);
